// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__EP_uZ","unreadBadge":"styles_unreadBadge__3Tdyk","modalContent":"styles_modalContent__2_2z-","modal":"styles_modal__3VInj"};